import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../constants';
import Button from './Button';
import Text from './styled/Text';

const NotificationContainer = styled.div`
  width: 376px;
  position: fixed;
  top: 40px;
  right: 40px;
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background-color: ${colors.white};
  border-left: 8px solid ${colors.green};
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0px 6px 12px 0px ${colors.navy}12;

  > button {
    margin: 0;
  }
`;

const Notification = ({ title, text, onClick, show, buttonName }) => {
  return (
    <NotificationContainer show={show}>
      <Text variant="body-bold" color={colors.green}>
        {title}
      </Text>
      <Text variant="body">{text}</Text>
      <Button size="small" variant="primary" onClick={onClick}>
        {buttonName}
      </Button>
    </NotificationContainer>
  );
};

Notification.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  show: PropTypes.bool.isRequired,
  buttonName: PropTypes.string,
};

Notification.defaultProps = {
  title: '',
  text: '',
  onClick: () => {},
};

export default Notification;
